import {useCallback} from 'react';

import {AppButton} from '@/components/Button';
import appContent from '@/services/content/appContent.typed';
import {twx} from '@/utils/tailwindUtils';

type RescheduleCalendarConfirmButtonProps = {
    selectedDate: Date | null;
    onConfirm: () => void;
    className?: string;
};

const RescheduleCalendarConfirmButton = ({
    selectedDate,
    onConfirm,
    className,
}: RescheduleCalendarConfirmButtonProps) => {
    const selectDateContent = appContent.getAutoDeliveryContent()?.rescheduleDeliveryContent?.selectDateContent;
    const {rescheduleDeliveryButton} = selectDateContent || {};

    const handleConfirmClick = useCallback(() => {
        if (!selectedDate) {
            return;
        }

        onConfirm?.();
    }, [onConfirm, selectedDate]);

    if (!rescheduleDeliveryButton?.text) {
        return null;
    }

    return (
        <AppButton
            primary
            light
            onClick={handleConfirmClick}
            disabled={selectedDate === null}
            className={twx('m-0 w-full', className)}
            aria-label={rescheduleDeliveryButton.alt}
        >
            {rescheduleDeliveryButton.text}
        </AppButton>
    );
};

export default RescheduleCalendarConfirmButton;
